import { useTranslation } from 'react-i18next';

import { ToggleButton } from '@/components/ui/custom/ToggleButton';
import { AccountAnalyticsFilters } from '@/modules/analytics/components/filters/AccountAnalyticsFilters/AccountAnalyticsFilters';
import { HumanAgentsEffectiveness } from '@/modules/analytics/components/HumanAgentsEffectiveness/HumanAgentsEffectiveness';
import { HumanAgentsExport } from '@/modules/analytics/components/HumanAgentsOverview/HumanAgentsExport';
import { HumanAgentsOverview } from '@/modules/analytics/components/HumanAgentsOverview/HumanAgentsOverview';
import { MY_PERFORMANCE_ALLOWED_FILTERS } from '@/modules/analytics/constants';
import { useTrackedComparison } from '@/modules/analytics/hooks/useComparisonMode';
import useSegments from '@/segment/useSegments';
import { PageName } from '@/shared/types/segment';

const MyPerformanceContent = () => {
  const { t } = useTranslation();
  const { isComparing, toggleComparison } = useTrackedComparison(PageName.ANALYTICS_MY_PERFORMANCE);
  return (
    <div className="mx-auto max-w-6xl">
      <AccountAnalyticsFilters
        page={PageName.ANALYTICS_MY_PERFORMANCE}
        allowedFilters={MY_PERFORMANCE_ALLOWED_FILTERS}
        rightActions={
          <ToggleButton pressed={isComparing} onClick={toggleComparison}>
            {t('analytics.compare_prev')}
          </ToggleButton>
        }
        exportActions={<HumanAgentsExport />}
      />
      <div className="space-y-6">
        <HumanAgentsOverview />
        <HumanAgentsEffectiveness />
      </div>
    </div>
  );
};

export const MyPerformance = () => {
  useSegments(PageName.ANALYTICS_MY_PERFORMANCE);
  return <MyPerformanceContent />;
};
